export default __webpack_public_path__ + "static/media/iconCardRequest.c3edbd4f.svg";